import { localStore, readSetting, writeSetting, type SettingsStore } from "../settings.ts";

/**
 * Whether the performance panel shows (ADR-087 decision 3), kept per viewer in this browser's storage and off by
 * default; F9 and Settings' Show performance both write it.
 */

/**
 * The storage key the setting lives under.
 */
export const PERFORMANCE_KEY = "odyssey.performance";

/**
 * Reads a stored value as the setting.
 *
 * @param raw The stored text, or null when nothing is stored.
 * @returns True only for exactly `on`.
 */
export function parsePerformance(raw: string | null): boolean {
  return raw === "on";
}

/**
 * Reads whether the panel shows.
 *
 * @param store Where it is kept; this browser's `localStorage` by default.
 * @returns The stored choice, or false when none is stored, it is malformed or the store cannot be read.
 */
export function readPerformance(store: SettingsStore | null = localStore()): boolean {
  return readSetting(PERFORMANCE_KEY, parsePerformance, store);
}

/**
 * Keeps whether the panel shows.
 *
 * @param shown Whether it shows.
 * @param store Where to keep it; this browser's `localStorage` by default.
 * @returns True when the store took it.
 */
export function writePerformance(shown: boolean, store: SettingsStore | null = localStore()): boolean {
  return writeSetting(PERFORMANCE_KEY, shown ? "on" : "off", store);
}
